import React, { useEffect } from 'react';
import styles from './match-found.module.scss';
import { Profile } from '@/types/profile';
import { GalleryImages } from '@/components/gallery-images';
import { Button, Typography } from '@/ui-kit';
import { routesApp } from '@/constans/routes';
import { generatePath } from 'react-router-dom';
import clsx from 'clsx';
import { CloseIcon } from '@/assets/icons';
import { useMatchFound } from '@/store/useMatchFound';
import { useTranslation } from 'react-i18next';

interface Props {
    userGender?: String | null;
    match?: Profile;
    chatId: number;
    clearProfileId: () => void;
}

export const MatchFound: React.FC<Props> = ({
    userGender,
    match,
    chatId,
    clearProfileId,
}) => {
    const { setMatchFound } = useMatchFound(state => state)

    useEffect(() => {
        console.log('match found mounted')
        setMatchFound(true)

        return () => {
            console.log('match found unmounted')
            setMatchFound(false)
        }
    }, [])

    const { t } = useTranslation();

    return (
        <div className={clsx(styles.wrapper, match && styles.visibleWrapper)}>
            <div className={styles.content}>
                <div
                    className={clsx(styles.closeIcon)}
                    onClick={() => clearProfileId()}
                >
                    <CloseIcon />
                </div>
                <div className={styles.galleryWrapper}>
                    <GalleryImages
                        photos={match?.photos ?? []}
                        isMatched={true}
                        isNeedRestrictGalleryWidget={false} />
                </div>
                <div className={styles.cardFooter}>
                    <Typography
                        fontWeight="bold"
                        typeColor="white"
                        className={styles.cardFooter__title}
                        fontFamily="SFProText"
                        variant="h4"
                        center>
                        {t('browse.new_match')}
                    </Typography>

                    <Typography
                        typeColor="white"
                        fontFamily="SFProText"
                        center
                        className={styles.cardFooter__text}
                        fontWeight="normal">
                        {t('browse.match_found', { name: match?.public_name })}
                    </Typography>
                    <Typography
                        typeColor="white"
                        fontFamily="SFProText"
                        center
                        className={styles.cardFooter__text}
                        fontWeight="normal">
                        {t(`browse.send_first.${userGender}_to_${match?.gender}`)}
                    </Typography>

                    <Button
                        isLink
                        to={generatePath(routesApp.chat, { id: String(chatId) })}
                        typeColor="white"
                        textColor="black">
                        {t('browse.go_to_chat_secondary')}
                    </Button>
                </div>
            </div>
        </div>
    );
};
